import { productVersionFromFirestore } from '@parallel-fluidics/shared/models/products';
import {
  collection,
  getDocs,
  getFirestore,
  orderBy,
  query,
} from 'firebase/firestore';

export default async function fetchProductVersions(productDocId) {
  const snapshot = await getDocs(query(
    collection(getFirestore(), 'products', productDocId, 'versions'),
    orderBy('createdAt', 'desc'),
  ));

  return snapshot.docs.map((doc) => productVersionFromFirestore(doc));
}
